import { Fragment } from 'react'
import { IntlProvider } from 'react-intl'
import { connect } from 'react-redux'

import messages from '../messages'
import { LANGUAGES } from './languages'
import { getLanguage } from '../../utils/languageUtils'

function Provider({ children, language = LANGUAGES.SQ }) {
  return (
    <IntlProvider
      language={language}
      textComponent={Fragment}
      messages={messages[language]}
      onError={() => {}}
    >
      {children}
    </IntlProvider>
  )
}

const mapStateToProps = () => ({
  language: LANGUAGES.SQ,
})

export default connect(mapStateToProps)(Provider)
